import React from 'react';
import {
    resume,
    resumeExperienceRowTransitionId,
    resumePdfHref,
    RESUME_PDF_FILENAME,
} from '../../Model/resume';
import ResumeRow from './ResumeRow';
import styles from './ResumeView.module.css';

/** Delay before each row’s paint-in wipe (ms); later rows start later. */
const ROW_STAGGER_IN_MS = 72;

export interface ResumeViewProps {
    phase: 'in' | 'out';
    transitionToken: number;
    onHideComplete: (id: string, token: number) => void;
}

const ResumeView: React.FC<ResumeViewProps> = ({ phase, transitionToken, onHideComplete }) => {
    return (
        <div className={styles.list}>
            <div className={styles.toolbar}>
                <a
                    className={styles.pdfButton}
                    href={resumePdfHref}
                    download={RESUME_PDF_FILENAME}
                >
                    Download PDF résumé
                </a>
            </div>
            {resume.experience.map((entry, index) => (
                <ResumeRow
                    key={resumeExperienceRowTransitionId(index)}
                    entry={entry}
                    transitionId={resumeExperienceRowTransitionId(index)}
                    staggerInMs={index * ROW_STAGGER_IN_MS}
                    phase={phase}
                    transitionToken={transitionToken}
                    onHideComplete={onHideComplete}
                />
            ))}
        </div>
    );
};

export default ResumeView;
